import React, { PureComponent } from 'react';
import Styles from '../constants/Styles';
// import { View, Text} from 'react-native';

import { DRButton } from '../components/DRControls';

export default class ReceiveMoxiScreen extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div
        style={{
          ...Styles.box,
          ...Styles.centeredContent,
          width: '100%',
          height: 364,
          marginTop: 200,
          alignSelf: 'center',
        }}
      >
        <div
          style={{
            fontWeight: 400,
            fontSize: 18,
          }}
        >
          To receive something, please contact
        </div>
        <div
          style={{
            fontWeight: 400,
            fontSize: 18,
          }}
        >
          the supplying department and they
        </div>
        <div
          style={{
            fontWeight: 400,
            fontSize: 18,
          }}
        >
          will order Moxi for you
        </div>
        <div style={{ marginTop: 70 }}>
          <DRButton
            action={() => this.props.closeModal()} // reason it is not this.props.closeModal is because the default param doesn't get passed in correctly otherwise
            fontColor={'#8785FF'}
            borderColor={'#8785FF'}
            phrase={'OKAY'}
          />
        </div>
      </div>
    );
  }
}

ReceiveMoxiScreen.navigationOptions = {
  header: null,
};

// Note: This is needed because publishing to expo runs minify, which changes the class names. In particular, classes
//       can end up with the same name which breaks the screen transition logic.
ReceiveMoxiScreen.viewName = 'ReceiveMoxiScreen';
